import "./header.css"
import { useContext, useState } from "react"
import { DataContext } from "src/contexts/DataContext"
import { TimingContext } from "src/contexts/TimingContext";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import { MenuContext } from "src/contexts/MenuContext";
import MenuIcon from '@mui/icons-material/Menu'; // Importing Menu icon from Material-UI

function ChildModal({ image_source }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={"jupyter-notebook-modal-button " + (open ? "open" : "closed")}>
      <img onClick={handleOpen} className="programming-language-icon" src={image_source} />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div id="notebook-iframe">
          <iframe src={"https://jkb-lab.nrp-nautilus.io"} />
        </div>
      </Modal>
    </div>
  );
}

function NotebookModalHeader() {
  return <div className="notebook-modal-header">
    <ChildModal image_source={"images/Python_Logo.png"} />
    <ChildModal image_source={"images/R_Logo.jpeg"} />
  </div>
}

function DatasetHeader() {
  const {isOpen, setIsOpen} = useContext(MenuContext)
  const {
    key,
    data
  } = useContext(DataContext)
  const { idx } = useContext(TimingContext)

  return <div className="dataset-name">
    <button className="hamburger" onClick={() => setIsOpen(!isOpen)}>
      <MenuIcon /> {/* Hamburger icon */}
    </button>
    <div className="key-header">
      DATASET NAME:
    </div>
    <div className="dataKey-title">
      {key}
    </div>
    <div>{
      data && idx && data[idx] && JSON.stringify(Object.assign(
        {},
        ...function _flatten(o) {
          return [].concat(...Object.keys(o)
            .map(k =>
              typeof o[k] === 'object' ?
                _flatten(o[k]) :
                ({ [k]: o[k] })
            )
          );
        }(["pitch", "roll", "heading"].map(k => {
          const obj = Object()
          obj[k] = data[idx][k].toFixed(3) / Math.PI * 180
          return obj
        }))
      ))
    }</div>
  </div>
}

export default function Header(props) {


  return <div id="header">
    <DatasetHeader />
    <NotebookModalHeader />
  </div>
}